import { render, staticRenderFns } from "./EventPopup.vue?vue&type=template&id=275fab2c&scoped=true&"
import script from "./EventPopup.vue?vue&type=script&lang=ts&"
export * from "./EventPopup.vue?vue&type=script&lang=ts&"
import style0 from "./EventPopup.vue?vue&type=style&index=0&id=275fab2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275fab2c",
  null
  
)

export default component.exports